import React, { Component } from 'react'
import { connect } from 'react-redux';
import classnames from 'classnames';
import { get } from 'lodash'

import { profileInvalidate, profileFetchIfNeeded, profileUpdateStages } from './../store/profile/actions';

import baseStyles from 'custom/base.styl';
// import check from 'custom/img/check@3x.png';

import checkIcon from 'custom/checkIcon';

const renderExampleLink = (name, link) => {
  if (!link) {
    return null;
  }
  return (<li><a target="_blank" href={link} rel="noopener noreferrer">{name}</a></li>);
};

class PageAwaitResult extends Component {
  componentDidMount() {
    const { load } = this.props;
    load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading && !this.stageChecked && this.props.stage !== 'await_result') {
      this.stageChecked = true;

      this.props.updateStage();
    }
  }

  render() {
    const { loading, taskData, profileVer, isUSA } = this.props;
    if (loading || !taskData) {
      return null;
    }

    const sumVer2 = isUSA ? '$20' : '$10';

    if (profileVer === 'v0') {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.content_wide)} key="registration-success-header">
          <div className={baseStyles.header}>
            <h2 className={baseStyles.title}>Well done!</h2>
          </div>
          <p className={classnames(baseStyles.succeess_title, baseStyles.space_bottom)}>You have submitted your final test essay!</p>
          <p className={classnames(baseStyles.content_board__text, baseStyles.space_bottom)}>This essay will be checked by our Freelancer Success Team and you will get <br /> an email notification with the results. Expect to get it <b>within 5 days after <br />submission or sooner.</b> If you are successful you will be ready to work on our <br /> platform right away! There are many orders awaiting so check your email <br /> regularly please. Meanwhile please see the examples of good and bad essays below and compare them to your third order.</p>
          <div className={baseStyles.upload_board}>
            <div className={baseStyles.upload_board_body}>
              <ul>
                {renderExampleLink('[Sample Good Essay]', taskData.good_essay_sample)}
                {renderExampleLink('[Grading Report for Good Essay]', taskData.good_essay_grading_report)}
                {renderExampleLink('[Sample Bad Essay]', taskData.bad_essay_sample)}
                {renderExampleLink('[Grading Report for Bad Essay]', taskData.bad_essay_grading_report)}
              </ul>
            </div>
            <a
              className={baseStyles.button_link}
              href={taskData.good_bad_all || ''}
              target="_blank"
              rel="noopener noreferrer"
            >Download all</a>
          </div>
        </div>
      );
    }

    if (profileVer === 'v1') {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered)} key="registration-success-header">
          <div className={baseStyles.header}>
            <img src={check} alt="check" width="61px" className={baseStyles.space_bottom} />
            <h2 className={classnames(baseStyles.title_middle, baseStyles.text_success)}>Congratulations!</h2>
          </div>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}> <b>You’ve completed all of the probation stages!</b> </p>
					<p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}> Our Recruiting Managers will check your test task and get back to you with the results within 2-5 business days. Stay tuned!</p>
        </div>
      );
    }

    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered)} key="registration-success-header">
        <div className={baseStyles.header}>
          {/* <img src={check} alt="check" width="61px" className={baseStyles.space_bottom} /> */}
          {checkIcon()}
          <h2 className={classnames(baseStyles.title_middle, baseStyles.text_success)}>Congratulations!</h2>
        </div>
        <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}> <b>You’ve completed all of the probation stages!</b> </p>
        <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}>
          Our Recruiting Managers will check your test task and get back to you with the results within 2-5 business days. Stay tuned!
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const user = state.profile.data && state.profile.data.user;
  const stage = user && user.stage;
  const activeTasks = user && user.active_tasks;
  const task = activeTasks && activeTasks.length && activeTasks[0];
  const taskData = task && task.task && task.task.data;
  const loading = !state.profile.data || state.profile.isFetching;
  const profileVer = user && user.scenario_version;

  const utmType = get(state.profile.data, 'user.profile.utm_type');
  const isUSA = utmType && utmType === 'usa';

  return {
    loading,
    taskData,
    profileVer,
    stage,
    isUSA,
  };
};

const mapDispatchToProps = dispatch => ({
  load: () => {
    dispatch(profileInvalidate());
    dispatch(profileFetchIfNeeded());
  },
  updateStage: () => dispatch(profileUpdateStages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageAwaitResult);



// WEBPACK FOOTER //
// ./src/components/PageAwaitResult.js